// 엔터프라이즈 전용 기능 — DCF 워크스페이스 · 금융상품 평가(RCPS).
// 딥서치 계정(엔터프라이즈)으로 로그인한 사용자만 메뉴·화면을 본다. 구글(베타) 로그인 사용자는
// 서버가 user.beta=true 를 내려주며, 이 값은 메뉴 노출에만 쓴다 — 실제 차단은 서버 미들웨어가
// 토큰 종류(vab.)로 매 요청 다시 본다(server.py enterprise_only_guard).
import { useAuth, type User } from "../stores/auth";

export const ENTERPRISE_ONLY_PATHS = ["/dcf", "/rcps"] as const;

export function isEnterpriseUser(user: User | null | undefined): boolean {
  return !!user && !user.beta;
}

export function isEnterpriseOnlyPath(path: string): boolean {
  return ENTERPRISE_ONLY_PATHS.some((p) => path === p || path.startsWith(`${p}/`) || path.startsWith(`${p}?`));
}

export function useIsEnterprise(): boolean {
  return isEnterpriseUser(useAuth((s) => s.user));
}
